export function supportsPassiveEvents() {
	let noop = () => {};
	let supported = false;

	try {
		let options = Object.defineProperty({}, "passive", {
			get() {
				return (supported = true);
			},
		});

		window.addEventListener("testPassiveEventSupport", noop, options);
		window.removeEventListener("testPassiveEventSupport", noop, options);
	} catch (e) {} // eslint-disable-line no-empty

	return supported;
}
